module.exports = {"TXTWCL_Close":{"id":"TXTWCL_Close","defaultMessage":"Fermer","track":"Close"}}